import React from 'react';
import ResultsBlock1Hero from '../resultados/ResultsBlock1Hero';
import ResultsBlock1_5Burden from '../resultados/ResultsBlock1_5Burden';
import ResultsBlock2Context from '../resultados/ResultsBlock2Context';
import ResultsBlock3Main from '../resultados/ResultsBlock3Main';
import ResultsBlock5Evolution from '../resultados/ResultsBlock5Evolution';
import ResultsBlock6Limits from '../resultados/ResultsBlock6Limits';

export default function ResultsPage() {
  return (
    <>
      <ResultsBlock1Hero />
      <ResultsBlock1_5Burden />
      <ResultsBlock2Context />
      <ResultsBlock3Main />
      <ResultsBlock5Evolution />
      <ResultsBlock6Limits />
    </>
  );
}
